export enum ChargeType {
  FedEx = 1,
  ReplacementLabel = 2,
  Repairs = 3,
  VehicleCleanUp = 4,
  Miscellaneous = 5
}
